export const awards = {
  awardsHero: {
    subtitle: 'AWARDS & ACTIVITIES',
    title: '获奖·社会活动',
  },
  manifesto: {
    title: 'GLOBAL RECOGNITION',
    subtitle: '联合国CSW70论坛 荣获"卓越贡献奖"',
    text: {
      paragraph1: {
        line1: '2026年3月10日，在纽约举办的',
        line2: '联合国妇女地位委员会第70届会议（CSW70）相关论坛上，',
        line3: '本学院的教育框架获得了国际社会的高度评价。',
      },
      paragraph2: {
        line1: '融合脑科学、行为心理学、成功哲学及最新AI技术的独特能力开发项目，',
        line2: '因其对女性赋权及可持续社会实现所作出的贡献，',
        line3: '由联合国经济及社会理事会（ECOSOC）特别协商地位团体IDIO，',
        line4: '向代表理事 廣瀬進二授予"Outstanding Contribution Award（卓越贡献奖）"。',
      },
    },
    speech: {
      caption: 'SPEECH AT UN CSW70 FORUM · NEW YORK · 2026',
      heading: 'THE NY MANIFESTO',
      subheading: '纽约国际会议 2026 ── 向世界的宣言',
      paragraph1: '每一个人都拥有无限的可能性。',
      paragraph2: '教育改变思维，思维改变行动，行动改变人生。\n这一连锁，正是创造可持续社会最为确实的结构。',
      paragraph3: '性别平等，不仅仅是权利的问题，\n更是整个社会的成长战略。\nDREAM CODE 为每一个人提供将自身可能性\n作为"结构"重新设计的框架。',
      paragraph4: '迈向一个不让任何人掉队的世界。\n我们将继续融合教育与科技，\n致力于让全世界的人都能实现自己的梦想。',
    },
    speechSignature: {
      name: 'Dream Realization Academy 理事长　廣瀬進二',
      date: 'March 10, 2026 / New York',
    },
    signature: {
      line1: 'Dream Realization Academy 理事長',
      line2: '廣瀬進二',
      line3: 'March 10, 2026 / New York',
    },
  },
  initiatives: {
    title: '联合国认可的三大社会变革模型',
    items: [
      {
        title: '自我肯定感与目标达成力的重构',
        description: '以单亲母亲和女童为对象，基于脑科学的教育支持，构建不依赖外部环境的"自立结构"。',
      },
      {
        title: '商业结构与收益的理解',
        description: '不仅提供支援，更通过面向女性创业者的商业教育项目，推动可持续的经济自立。',
      },
      {
        title: '培育下一代数字领袖',
        description: '将AI与数字技术融入课程，塑造下一代社会女性领袖的认知模型。',
      },
    ],
  },
  activities: {
    title: '回馈社会',
    description: 'DREAM CODE的教育体系被广泛应用于企业培训、社区活动、教育支援等各个领域，持续创造可持续的成果。',
    link: '查看我们的社会贡献活动',
  },
};